<div class="flex flex-col gap-4 h-full min-h-0 flex-1 p-4">

    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <div class="flex flex-row items-center gap-3 w-full sm:w-auto">
            <app-button variant="filled" severity="primary" label="Map tag types" icon="pi pi-plus"
                (clicked)="openConnectProjectTagDialog()" />
            <app-search-bar placeholder="Search tag types" [(ngModel)]="searchProjectTagType"
                (searchChange)="searchProjectTagTypeChange(searchProjectTagType)" class="w-full sm:w-54" />
        </div>
    </div>

    <div class="flex flex-col gap-4 overflow-y-auto flex-1 min-h-0">

        <h2 class="text-lg font-semibold">Default Project Tags</h2>
        <div class="flex flex-col gap-3">
            @if (filteredFixedProjectTags.length === 0 && searchProjectTagType) {
            <p class="text-center text-gray-500">No Default Tags found</p>
            }
            @for (fixed of filteredFixedProjectTags; track fixed.name) {
            <p-card pDraggable class="tag-card border">
                <div class="flex flex-row gap-4 items-center w-full">
                    <div class="flex flex-row justify-between items-center w-full">
                        <div class="flex flex-row items-center gap-3">
                            <app-icon [type]="fixed.icon" [source]="'primeng'"></app-icon>
                            <span class="font-semibold">{{ fixed.name }}</span>
                        </div>
                    </div>
                </div>
            </p-card>
            }
        </div>

        <h2 class="text-lg font-semibold">Connected Tag Types</h2>

        @if (projectTagTypeLoading) {
        @for (item of getSkeletonCount(5); track $index) {
        <div class="h-20">
            <p-skeleton width="100%" height="100%" />
        </div>
        }
        }
        @else {
        @if (!projectTagType || projectTagType.length === 0) {
        <p class="text-center text-gray-500">No Connected Tag Types found</p>
        }
        @for (tag of projectTagType; track tag._id) {

        <p-card pDraggable pDroppable (onDragStart)="dragStart($index)" (onDrop)="dropTag($index)" dragEffect="move"
            class="tag-card border">
            <div class="flex flex-row gap-4 items-center w-full">
                <i class="pi pi-bars cursor-move text-gray-400"></i>
                <div class="flex flex-row justify-between items-center w-full">
                    <div class="flex flex-row items-center gap-3">
                        <app-icon [type]="TAG_DATA_TYPES_ICONS[tag.dataType]" [source]="'svg'"></app-icon>
                        <span class="font-semibold">{{ tag.name }}</span>
                    </div>

                    <app-button variant="outlined" severity="danger" label="Delink" icon="pi pi-trash"
                        (clicked)="delinkLinkedTag(tag)" />
                </div>
            </div>
        </p-card>
        }
        }
    </div>
</div>


<app-file-selection [(visible)]="connectProjectTagDialogVisible" [config]="fileSelectionConfig" [fetch]="fetchTagTypes"
    [fileItemTemplate]="tagItemTemplate" [selectedFileTemplate]="tagSelectedTemplate"
    (onSubmit)="submitProjectTagSelection($event)">
    <ng-template #tagItemTemplate let-file let-selected="selected" let-toggleSelection="toggleSelection">
        <div class="flex flex-row items-center gap-3">
            <app-checkbox [value]="selected" (onChange)="toggleSelection($event)" [config]="{ binary: true }" />
            <span class="text-sm text-gray-900">{{ file.name }}</span>
        </div>
    </ng-template>

    <ng-template #tagSelectedTemplate let-file let-toggleSelection="toggleSelection">
        <div class="flex items-center justify-between">
            <span class="text-sm text-gray-900">{{ file.name }}</span>
            <app-button variant="outlined" severity="danger" icon="pi pi-trash" size="sm"
                (clicked)="toggleSelection({ checked: false })" />
        </div>
    </ng-template>
</app-file-selection>